<div class="characteristics-type-filter">

  <div
    class="characteristics-type-filter__group"
    *ngFor="let filter of filterGroup"
  >

    <div class="characteristics-type-filter__group--header">
      {{filter.groupName}}
    </div>

    <div class="characteristics-type-filter__group--body">
      <lib-multi-selection
        [options]="filter.options"
        (optionToggled)="sendEventForSelectedOptions(filter.groupName, filter.options)"
        (optionsToggled)="emit()"
      >
      </lib-multi-selection>
    </div>

  </div>

</div>

<ng-template #clearTemplate>
  <span
    class="search-filter__extra"
    [ngClass]="{
    'text-primary': this.value.length,
    'text-muted': !this.value.length
    }"
    (click)="cleanFilter($event)"
  >
    Limpar Filtros
  </span>
</ng-template>
